export enum orderStatusApproveRejet {
  all = 0,
  approved = 1,
  pending = 2,
  reject = 3,
  comment = 4,
  REPLANNING = 5,
  IN_PROGRESS = 6,
  ASSIGNED_PM = 7,
  REVIEW_OFFER = 8,
  IN_REVIEW = 9,
  Refused = 10,
  TO_BE_COMPLETED=13
}

export enum statusApproveRejet {
  all = 1,
  pending = 2,
  reject = 6,
  approved = 8,
  comment = 9,
  INACTIVE=4

}

export enum ExecuteOrderStatus {
  NotStarted = 1,
  InProgress = 2,
  Completed = 3,
  All = 0,
  Assigned = 6,
  INACTIVE=4,
  COMPLETED_INACTIVE = 5,
  Planned = 8,
  ReviewOrder = 9,
  Approved = 10,
  Reject = 11,
  Unplanned = 14,
}

export enum TASK_INVOICE_STATUS {
  TO_BE_INVOICED = 1,
  INVOICED = 2,
  COLLECTED = 3,
  ADVANCE_PAYMENT = 4,
}

export enum ORDER_INVOICE_STATUS {
  TO_BE_INVOICED = 1,
  PARTIALLY_INVOICED = 2,
  COMPLETED = 3,
}

export enum ExecuteOrderListStatus {
  NotStarted = 'Not Started',
  InProgress = 'In Progress',
  Completed = 'Completed',
  All = 'All',
  INACTIVE= 'Archived',
  COMPLETED_INACTIVE = 'In Active',
  ReviewOrder = 'Review Order',
  Rejected = "Rejected",
}
export enum PeopleType {
  Supplier = 1,
  Consultant = 2,
  People = 3,
}





export enum TaskStatus {
  ALL = 0,
  NOT_STARTED =	1,
  IN_PROGRESS =	2,
  COMPLETED =	3,
  NOT_REQUIRED	= 4,
  ON_HOLD	= 5,
  RE_ASSIGN = 6,
  RE_OPEN = 7,
}

export enum ExecuteOrderStatusText {
  ALL= 'All',
  NotStarted = 'Not Started',
  InProgress = 'In Progress',
  Completed = 'Completed',
  NotRequired = 'Not Required',
  OnHold = "OnHold",
  ReAssign = "Reassigned",
  ReOpen = "Reopen",
  Planned = "Planned",
}

export enum ApprovedOrderLogsType {
  ORDER_STARTED = 1,
  ORDER_COMPLETED = 2,
}

export type DateFilterOption = 'THIS_YEAR' | 'THIS_MONTH' | 'CUSTOM';

export type popupType = 'Orders' | 'Customers';
export interface DateFilter {
  label: string;
  value: DateFilterOption;
}

export enum PMFeesStatus{
  ALL = 0,
  NOT_STARTED =	1,
  IN_PROGRESS =	2,
  COMPLETED =	3,
}